import React from "react";
import InTheNews from "@/components/in-the-news/InTheNews";
import MetaComponent from "@/components/common/MetaComponent";

const metadata = {
  title: "Hubzu | In The News",
};

const InTheNewsScreen = () => {
  return (
    <>
      <MetaComponent meta={metadata} />
      <InTheNews />
    </>
  );
};

export default InTheNewsScreen;
